import React from 'react'
import Pagination from '../../../components/Pagination'
import {
  fetchPaginatedPatientsAsync,
  fetchPatientsAsync,
  selectPatientsCurrentPage,
  selectPatientsNext,
  selectPatientsPrevious,
  selectPatientsStatus,
  selectPatientsTotal,
  setCurrentPage,
} from '../patientsSlice'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'
const PatientNavigation = () => {
  const next = useAppSelector(selectPatientsNext)
  const previous = useAppSelector(selectPatientsPrevious)
  const total = useAppSelector(selectPatientsTotal)
  const current = useAppSelector(selectPatientsCurrentPage)
  const status = useAppSelector(selectPatientsStatus)
  const dispatch = useAppDispatch()

  const goBack = () => {
    dispatch(fetchPaginatedPatientsAsync(previous ?? ''))
    if (current > 1) {
      dispatch(setCurrentPage(current - 1))
    }
  }

  const goNext = () => {
    dispatch(fetchPaginatedPatientsAsync(next ?? ''))
    dispatch(setCurrentPage(current + 1))
  }

  return (
    <div
      className='text-right'
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        boxSizing: 'border-box',
        border: '1px solid lightgrey',
        background: 'white',
        height: '35px',
        paddingRight: '53px',
        fontSize: '9px !important',
      }}
    >
      <Pagination
        total={total}
        current={current}
        handleChange={() => dispatch(fetchPatientsAsync())}
      />
      <div className='inline-block patients-pagination-content'>
        <button
          disabled={status === 'loading'}
          className={`icon-disable-btn ${previous ? '' : 'disableBtn'}`}
          onClick={() => goBack()}
        >
          <KeyboardArrowLeft />
        </button>
        <button
          disabled={status === 'loading'}
          className={`icon-disable-btn ${next ? '' : 'disableBtn'}`}
          onClick={() => goNext()}
        >
          <KeyboardArrowRight />
        </button>
      </div>
    </div>
  )
}

export default PatientNavigation
